<div class="container-fluid padding-top">
  <md-card>
    <div class="row">
      <div class="col-md-12 text-center">
        <h1>{{ clientData?.name}}</h1>
      </div>
      <div class="col-md-12">
        <h2>Email Settings</h2>
      </div>
    </div>

    <div *ngIf="clientData">
      <div class="row">
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [emailDBName]="'rentalConfirmation'"
                                 [emailName]="'Rental Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [emailDBName]="'reservationConfirmation'"
                                 [emailName]="'Reservation Confirmation'"></scs-site-admin-emails>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [emailDBName]="'changeOfAutoPayConfirmation'"
                                 [emailName]="'Auto Pay Change Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [emailDBName]="'moveOutDateConfirmation'"
                                 [emailName]="'Move Out Date Confirmation'"></scs-site-admin-emails>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [emailDBName]="'newAccountCreation'"
                                 [emailName]="'New Web Account Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [emailDBName]="'passwordReset'"
                                 [emailName]="'Password Reset Confirmation'"></scs-site-admin-emails>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [emailDBName]="'paymentConfirmation'"
                                 [emailName]="'Online Payment Confirmation'"></scs-site-admin-emails>
        </div>
        <div class="col-md-6">
          <scs-site-admin-emails [clientData]="clientData"
                                 [emailDBName]="'reportAProblem'"
                                 [emailName]="'Mobile App: Report a Problem'"></scs-site-admin-emails>
        </div>
      </div>
    </div>
  </md-card>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/email-settings/email-settings.component.html